/*
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-10-13 16:26:18
 * @LastEditTime: 2021-12-31 16:17:17
 */
function getQuery(url) {
  const urlParams = url.split('?')[1]
  const obj = {}
  if (urlParams) {
    const arr = urlParams.split('&')
    for (let i = 0; i < arr.length; i++) {
      const params = arr[i].split('=')
      obj[params[0]] = params[1]
    }
  }
  return obj
}

export function getUserSource() {
  const s = localStorage.getItem('source')
  if (s) {
    try {
      return JSON.parse(s)
    } catch (e) {
      return
    }
  }
  return null
}

function isPromotionUrl(url) {
  const keyword = ['from', 'utm_source', 'ref']
  const query = getQuery(url)
  let ret = false
  keyword.forEach(function(e) {
    if (Object.prototype.hasOwnProperty.call(query, e)) {
      ret = true
    }
  })
  return ret
}

function saveUserSource() {
  const source = {
    referer: null,
    target: null
  }
  // 获取referer
  if (document.querySelector('.referer')) {
    source.referer = document.querySelector('.referer').innerHTML
  }
  // 获取target
  source.target = location.href
  localStorage.setItem('source', JSON.stringify(source))
}

// User source
export function setUserSource() {
  const lastSource = getUserSource()
  if (!lastSource) { // 没有source，说明是第一次访问，直接保存
    saveUserSource()
  } else { // 非第一次访问
    if (isPromotionUrl(location.href)) { // 如果是推广链接，覆盖保存值
      saveUserSource()
    }
  }
}
